import $ from 'jquery';

export default () => {
  $(document).ready(function () {
    var pathname = window.location.pathname;
    var isArabic = pathname.split('/')[1] == 'ar';
    if (isArabic) {
      var purePathname = pathname.split('/ar/')[1];
      $('[data-language-button]').attr('href', '/' + purePathname);
    } else {
      $('[data-language-button]').attr('href', '/ar' + pathname);
    }
  });
}